
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m20.0297 6.76406-5.0438-5.04375c-.1406-.14062-.3304-.22031-.5297-.22031h-9.9562c-.41484 0-.75.33516-.75.75v19.5c0 .4148.33516.75.75.75h15c.4148 0 .75-.3352.75-.75v-14.45391c0-.19922-.0797-.3914-.2203-.53203zm-1.5094.87656h-4.4109v-4.41093zm.0422 13.17188h-13.125v-17.625h7.0781v5.0625c0 .26107.1037.51145.2883.69606.1846.1846.435.28832.6961.28832h5.0625zm-6.75-6.3281h-4.3125c-.10313 0-.1875.0844-.1875.1875v1.125c0 .1031.08437.1875.1875.1875h4.3125c.1031 0 .1875-.0844.1875-.1875v-1.125c0-.1031-.0844-.1875-.1875-.1875zm-4.5-3v1.125c0 .1031.08437.1875.1875.1875h9c.1031 0 .1875-.0844.1875-.1875v-1.125c0-.1031-.0844-.1875-.1875-.1875h-9c-.10313 0-.1875.0844-.1875.1875z","fill":"#4a3428"}})])
          )
        }
      }
    